import React from 'react';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import { PropTypes } from 'prop-types';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import styles from './OrderConfirmPage.css';
import LinkButton from '../../components/LinkButton';
import HeroText from '../../components/HeroText';
import OrderConfEmailForm from '../../components/Forms/OrderConfEmailForm';

const OrderConfirmPageLayout = ({ orderNumber }) => {
  return _.isEmpty(orderNumber) ? (
    <Redirect to="/" />
  ) : (
    <div className={styles.container}>
      <Menu dark />
      <Header />
      <HeroText ordernum={orderNumber} />
      <OrderConfEmailForm />
      <p className={styles.helpText}>
        <strong>Need to refill another Rx?</strong>
      </p>
      <LinkButton to="/" className={styles.button}>
        <span>Refill More</span>
      </LinkButton>
    </div>
  );
};

OrderConfirmPageLayout.propTypes = {
  orderNumber: PropTypes.string.isRequired,
};

export default OrderConfirmPageLayout;



// WEBPACK FOOTER //
// ./src/containers/OrderConfirmPage/OrderConfirmPageLayout.jsx